import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';

//获取租户门户列表
export const getTenantPortals = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/decoration/portal', params);
};
